import styled from "styled-components";

export const VariantContainer = styled.div`
  padding: 0 17px;
  display: flex;
  flex-direction: column;
`;
